// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1vyRU","amount":"Amount_amount__1GLfp","tip":"Amount_tip__32kwm","tipHeader":"Amount_tipHeader__LdCzv","tipsWrap":"Amount_tipsWrap__-B4wR"};